// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import '~/assets/scss/style.scss'
import AsyncComputed from 'vue-async-computed'
import VueHead from 'vue-head'
import VueFadeSlider from '~/plugins/fadeSlider'
import VueDateFormat from '~/plugins/dateFormat'
import VueKerning from '~/plugins/kerning'
import VueWindowState from '~/plugins/windowState'
import VueInview from '~/plugins/vue-inview'
import VueAHTML from '~/plugins/vue-ahtml'
import VueWHTML from '~/plugins/vue-whtml'
// import VueAccordion from '~/plugins/vue-accordion'
// import VueCollapse from 'vue2-collapse'
// import VueCollapse from '~/plugins/vue-collapse'

import VueScrollTo from 'vue-scrollto'
import VueAgile from 'vue-agile'
import * as VueGoogleMaps from 'vue2-google-maps'
import VeeValidate from 'vee-validate'
import VueAnalytics from 'vue-analytics'

import DominantColor from '~/plugins/dominant-color'
import ScrollAnimationUnit from '~/plugins/scroll-animation-unit'
import ColorOverlay from '~/plugins/color-overlay'
import ScrollSpy from '~/plugins/scroll-spy'

Vue.config.productionTip = false
Vue.use(AsyncComputed)
Vue.use(VueHead, {
  separator: ''
})
Vue.use(VueWindowState)
Vue.use(VueFadeSlider)
Vue.use(VueDateFormat)
Vue.use(VueKerning)
Vue.use(VueInview)
Vue.use(VueAHTML)
Vue.use(VueWHTML)

// Vue.use(VueAccordion)
// Vue.use(VueCollapse)

Vue.use(VueAgile) // Document: https://github.com/lukaszflorczak/vue-agile/
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease-out',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false
})
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA_Rd7FGIwZuuuk0K1PMEl806yypZsOum4',
    v: 3,
    language: 'en'
  }
})
Vue.use(VeeValidate)

Vue.use(VueAnalytics, {
  id: 'UA-119013048-1', // Production
  // id: '', // Development
  router,
  autoTracking: {
    pageviewTemplate (route) {
      return {
        page: route.fullPath,
        title: document.title,
        location: window.location.href
      }
    }
  }
});


Vue.use(DominantColor)
Vue.use(ScrollAnimationUnit)
Vue.use(ColorOverlay)
Vue.use(ScrollSpy)

// sync(store, router)
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js